import {
    CardProvider,
    CardProviderOptionsState,
    CardProviderOptionsResponse,
    FetchState
} from "@/shared/types";
import * as CardService from "@/shared/api/cardService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import _ from "lodash";

export const initialState: CardProviderOptionsState = {
    fetchState: FetchState.Uninitialized,
    cardProvider: CardProvider.None,
    capability: null
};

export const useCardProviderOptionsStore = defineStore("cardProviderOptions", {
    state: (): CardProviderOptionsState => (_.cloneDeep(initialState)),
    getters: {
        isLoaded: state => state.fetchState === FetchState.Loaded,
        canManageCard: state => {
            if (state.fetchState !== FetchState.Loaded) return false;

            if (state.cardProvider === CardProvider.None) {
                // non-HSAB custodied HSA, this case shouldn't happen,
                // but we don't want to suppress UI elements if it does
                return true;
            }

            if (state.cardProvider === CardProvider.Fiserv) return state.capability.canManageCard;
            // else CardProvider === Wex
            const hsabAccountsStore = useHsabAccountsStore();
            return hsabAccountsStore.debitCardsAvailable && state.capability.canManageCard;
        }
    },
    actions: {
        setFetchState (fetchState: FetchState) {
            this.fetchState = fetchState;
        },
        setCardProviderOptions (cardProviderOptions: CardProviderOptionsResponse) {
            this.cardProvider = cardProviderOptions.cardProvider;
            this.capability = cardProviderOptions.capability;
            this.fetchState = FetchState.Loaded;
        },
        getCardProviderOptions (): Promise<any> {
            if (this.fetchState !== FetchState.Uninitialized) {
                return Promise.resolve();
            }

            this.setFetchState(FetchState.Loading);
            const hsabAccountsStore = useHsabAccountsStore();
            hsabAccountsStore.getHsabAccounts();
            return CardService.getCardProviderOptions()
                .then(response => {
                    this.setCardProviderOptions(response.data);
                }).catch(err => {
                    return storeHelper.handleError({ error: err, rethrow: true});
                });
        }
    }
});